import React from 'react'
import {
  ModalHeader as ReactstrapModalHeader,
  ModalHeaderProps,
} from 'reactstrap'

export const ModalHeader: React.FC<ModalHeaderProps> = props => {
  return <ReactstrapModalHeader {...props} />
}
